import {ServiceRequest} from "src/utils/service-request"
import { MOTOR_CADASTRO_STATUS_PATH, MOTOR_CADASTRO_CONTADORES_PATH, MOTOR_CADASTRO_EXPORT_CSV_PATH} from "src/utils/api-routes"

class MotorStatusCadastroService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async loadContadoresCadastro(){
        return this.request.get(`${MOTOR_CADASTRO_CONTADORES_PATH}`)
    }

    async loadStatusCadastro(cetip, versao, limit, offset) {
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versao) params.append("VersaoDocumento", versao)
        if (limit) params.append("limit", limit)
        if (offset !== undefined) params.append("offset", offset)

        const query = params.toString() ? `?${params.toString()}` : ""

        console.log("loadStatusCadastro URL:", `${MOTOR_CADASTRO_STATUS_PATH}${query}`)

        return this.request.get(`${MOTOR_CADASTRO_STATUS_PATH}${query}`)
    }

    async exportStatusAnaliticoCSV(cetip, versaoDocumento) {
        console.log("exportCSV params:", { cetip, versaoDocumento })
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versaoDocumento) params.append("VersaoDocumento", versaoDocumento)

        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.post(`${MOTOR_CADASTRO_EXPORT_CSV_PATH}${query}`)
    }

}

export default MotorStatusCadastroService